// KARTE イベントデータの型定義
export interface KarteEventData {
  [key: string]: string | number | boolean | undefined | null
}

export interface KarteUserData {
  userId?: string | number
  email?: string
  name?: string
  [key: string]: string | number | boolean | undefined | null
}

// ページロードごとのview送信フラグ（初回ロードでリセット）
let hasViewEventSent = false

// ページ遷移時にviewイベント送信フラグをリセット
export function resetViewEventFlag(): void {
  hasViewEventSent = false
}

//KARTEトラッカーを初期化し、viewイベントを送信
export function karteTracker(): void {
  // 送信済みの場合は何もしない
  if (hasViewEventSent) {
    return
  }

  // staging と production 環境のみ実行
  if (
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'staging' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'
  ) {
    return
  }

  /**
   * window.krtが利用可能になるまで待機してviewイベントを送信
   * @param loopLimit 最大試行回数
   * @param i 現在の試行回数
   */
  function searchTrackerLoop(loopLimit: number, i: number): void {
    if (i > loopLimit || hasViewEventSent) return

    setTimeout(() => {
      if (window.krt && typeof window.krt === 'function') {
        window.krt('send', 'view')
        hasViewEventSent = true
      } else {
        searchTrackerLoop(loopLimit, ++i)
      }
    }, 300)
  }

  try {
    if (window.krt) {
      if (typeof window.krt === 'function') {
        window.krt('send', 'view')
        hasViewEventSent = true
      } else {
        searchTrackerLoop(3, 0)
      }
    } else {
      // 'window.krt'が確認できなければ300ms毎に再起(max3回)
      searchTrackerLoop(3, 0)
    }
  } catch (e) {
    // エラー時も'window.krt'の再確認
    searchTrackerLoop(3, 0)
  }
}

/**
 * KARTEカスタムイベントを送信
 *
 * 基本的なイベント送信関数。どこからでも呼び出し可能。
 * Reactコンポーネント内でユーザー情報の自動同期が必要な場合は、hooks/useKarte.ts の useKarte フックを使用
 *
 * @param eventName イベント名
 * @param eventData イベントデータ
 */
export function sendKarteEvent(eventName: string, eventData?: KarteEventData): void {
  // staging と production 環境のみ実行
  if (
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'staging' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'
  ) {
    return
  }

  try {
    if (window.krt) {
      if (typeof window.krt === 'function') {
        window.krt('send', eventName, eventData)
      } else {
        console.warn('[KARTE] window.krt exists but is not a function:', typeof window.krt)
      }
    } else {
      console.warn('[KARTE] window.krt is not available')
    }
  } catch (e) {
    console.error('[KARTE] tracking error:', e)
  }
}

/**
 * KARTEユーザー情報を設定
 * @param userData ユーザー情報
 */
export function setKarteUser(userData: KarteUserData): void {
  // staging と production 環境のみ実行
  if (
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'staging' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT !== 'production'
  ) {
    return
  }

  try {
    if (window.krt) {
      if (typeof window.krt === 'function') {
        window.krt('send', 'user', userData)
      }
    }
  } catch (e) {
    console.error('[KARTE] user tracking error:', e)
  }
}
